<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true">
      {{ title }}
    </el-button>

    <el-dialog
      title="下载账单"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <el-form :model="form" :rules="CHECK_CODE" ref="codeRef" @submit.native.prevent>
        <el-form-item label="请输入验证码" label-width="110px" prop="valCode">
          <el-input
            :placeholder="'请输入验证码'"
            :maxlength="4"
            v-model="form.valCode"
          ></el-input>

          <span
            v-html="codeHtml"
            @click="getCaptchaDetail"
            style="vertical-align: sub"
          ></span>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>

        <el-button type="primary" @click="onSubmit" :loading="exporting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, unref, toRefs, watch } from '@vue/composition-api'
import { getCaptcha } from '@/api/channel-api.js'
import { CHECK_CODE } from '@/views/channel/rules/validate-rule.js'
export default {
  // 组件名称
  name: 'ExportBill',
  props: {
    title: {
      type: String,
      default: '下载账单',
    },
    Fn: {
      type: Function,
      default: null,
    },
  },
  components: {},
  setup(props) {
    const state = reactive({
      codeHtml: '',
      dialogVisible: false,
      exporting: false,
      form: {
        valCode: '',
      },
    })
    const codeRef = ref(null)
    const getCaptchaDetail = async () => {
      try {
        let { result } = await getCaptcha({})
        state.codeHtml = result
      } catch {
        state.codeHtml = ''
      }
    }
    getCaptchaDetail()
    const onSubmit = async () => {
      try {
        await unref(codeRef).validate()
      } catch {
        return false
      }
      try {
        state.exporting = true
        props.Fn()
      } catch (error) {
        console.log(error)
      } finally {
        state.exporting = false
        state.dialogVisible = false
      }
    }
    watch(
      () => state.dialogVisible,
      (val) => {
        if (!val) {
          codeRef.value.resetFields()
        }
      },
    )
    return {
      ...toRefs(state),
      getCaptchaDetail,
      CHECK_CODE,
      onSubmit,
      codeRef,
    }
  },
}
</script>
